/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { useDispatch } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../action';
import { const_var, params } from '../../../../../../../redux/reducers/reducer'

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();

    const [wallCloseState, setWallCloseState] = useState(0);

    const backStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03,  (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2,  (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2, 0);
            model.closePath();
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope && params.freeStandingSide === "left", wallCloseState, params.p_c_p_l])

    const backStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03,  (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05,  (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05, 0);
            model.closePath();
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope && params.freeStandingSide === "left", wallCloseState, params.p_c_p_l]);

    const mainTrimModel = useMemo(() => {
     
        /**********************cutting hole using CSG for Wainscot************************/
        const storageLength = params.p_d - parseInt(params.p_u_t) + 0.18
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings( params.p_d - storageLength + 0.35)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.position.set(-(params.p_d / 2 - storageLength) - 0.2 ,3, -(params.p_w / 2));
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.rotateY(Math.PI);
        meshWainscotDelModel_Temp.position.set(params.endStoragePositionZ, 0, -(params.p_w / 2 - 0.5));
        meshWainscotDelModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);

        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGwainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        return {
            wTrim: CSGwainscotTrimModel.geometry
        }

        /****************************************************************/
    }, [params.p_d, params.p_w, params.p_u_c, params.p_u_t, params.p_l_w, const_var.newDoorsArray, wallCloseState, params.endStoragePositionZ]);

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : params.p_h

        if (params.p_l_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_l_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_l_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_l_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_l_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_l_w) - 0.2;
        }
        
        if (params.p_c_p_l) {
            if (params.p_l_w === 'Open') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }

        if (params.add_left_lean) {
            let leanFinalHeight = 0;
            if (params.leanStyle?.left === 'standard') leanFinalHeight = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p)/12) * params.lean_p_w);
            else leanFinalHeight = params.p_h - params.lean_p_h;

            if (params.add_left_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_l_w) * 3) -leanFinalHeight < 3)
            {    
                let wH = leanFinalHeight+0.2;
                tempCutState = params.p_h - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
            } else {
                if(!isNaN(params.p_l_w)) {
                    let wH = (3 * params.p_l_w) - 0.2;
                    tempCutState = finalHeight - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                    if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                }   
            }
            if (tempCutState === 0 && params.p_l_w === 'Open') tempCutState = -1; 
        }
        if (params.p_c_p_l && params.add_left_lean) {
            setWallCloseState(tempCutState - 1.5);
            dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': tempCutState - 1.5}))
        } else {
            setWallCloseState(tempCutState);
            dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': tempCutState}))
        }
    }, [params.p_r_s, params.p_w, params.p_l_w, params.p_c_p_l, params.p_h, params.add_left_lean, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.singleSlope && params.freeStandingSide === "left", params.leanStyle?.left])

    return (
        <group name='c_b_l_s_w_trim-group' rotation={[0, Math.PI / 2, 0]}>   
            <>
                {params.p_l_w !== 'Close' && 
                    <>
                        {params.endStoragePositionZ !== (params.p_d - parseInt(params.p_u_t)) && 
                            <>
                                <mesh name="back-storage-back-trim-one" position={[-0.22, 0, -(params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelOne, extrudeSettings(0.068)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                                <mesh name="back-storage-back-trim-two" position={[-0.27, 0, -(params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelTwo, extrudeSettings(0.23)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>  
                            </>
                        }
                        {params.endStoragePositionZ !== 0 && 
                            <>
                                <mesh name="back-storage-front-trim-one" position={[(parseInt(params.p_u_t) + 0.25) - 0.22, 0, -(params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelOne, extrudeSettings(0.068)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                                <mesh name="back-storage-front-trim-two" position={[(parseInt(params.p_u_t) + 0.4) - 0.17, 0, -(params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelTwo, extrudeSettings(0.23)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                            </>
                        }
                         
                    </> 
                }   
            </>
  
            {params.p_w_c_n === true && mainTrimModel.wTrim && (
                <mesh name="wainscotLeftTrim" geometry={mainTrimModel.wTrim}>
                    <MaterialWainScotTrimNew visibleSection={"center"}  />
                </mesh>
            )}
        </group>
    )
}

export default TrimModel